import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { removeProveedorComprador } from "../../../../../../../../redux/actions/resolucion";
import ProvedoresTable from "./ProveedoresTable";
import ProveedoresFormContainer from "./form/ProveedoresFormContainer";

const ProveedoresTableContainer = ({ esComprador = false }) => {
    const dispatch = useDispatch();
    const [openProveedoresForm, setOpenProveedoresForm] = useState(false);
    const [proveedor, setProveedor] = useState();
    const proveedores = useSelector((state) => esComprador ? state.resolucion.abmSustancia.compradores : state.resolucion.abmSustancia.proveedores);

    const handleOpenForm = (proveedor) => {
        setProveedor(proveedor);
        setOpenProveedoresForm(true);
    }
    const handleDelete = (indices) => {
        dispatch(removeProveedorComprador(indices, esComprador));
    }

    return (
        <>
            <ProvedoresTable
                esComprador={esComprador}
                data={proveedores}
                handleOpenForm={handleOpenForm}
                handleDelete={handleDelete}
            />
            <ProveedoresFormContainer
                esComprador={esComprador}
                open={openProveedoresForm}
                formValues={proveedor}
                handleClose={() => setOpenProveedoresForm(false)}

            />
        </>

    )
}

export default ProveedoresTableContainer;